import 'utils/sentry';
import { publish, AGENT_LOADED } from 'utils/pubsub';
import { initializeOptimizely } from 'utils/optimizely';
import initPublicApi from 'public-api/init';
import { initRemoveFromList } from 'apps/initRemoveFromList/init';
import { initAddToList } from 'apps/initAddToList/init';
import { initGetLists } from 'apps/initGetLists/init';

// On May 23rd 2025, we identified a race condition where list-agent attempts to initialize
// before window.ikea.pubsub.subscribe is available, causing errors in agent.tsx.
// This issue likely emerged after the CloudFlare CDN migration, though it cannot be confirmed.
// The following workaround ensures subscribe is available before initializing the agent.
const waitForPubSub = async (): Promise<void> => {
    const timeout = 5000;
    const interval = 100;
    const startTime = Date.now();

    while (Date.now() - startTime < timeout) {
        if (typeof window.ikea?.pubsub?.subscribe === 'function') {
            return;
        }
        await new Promise(resolve => setTimeout(resolve, interval));
    }

    throw new Error("Favs-Agent: Can't init: pubsub.subscribe not available");
};

export async function init() {
    if (!window.ikea) {
        throw Error('Favs-Agent: window.ikea is missing');
    }
    try {
        await waitForPubSub();
    } catch (error) {
        console.error(
            error instanceof Error ? error.message : 'An unknown error occurred'
        );
        return;
    }
    window.ikea.favourites = {
        agentLoaded: true,
        addToFavourites: initAddToList(),
        removeFromFavourites: initRemoveFromList(),
        internal_getLists: payload => initGetLists(payload),
    };
    window.ikea.pubsub.subscribe(
        'ikeaCookieConsent/changed',
        initializeOptimizely
    );
    initPublicApi();
    initializeOptimizely();

    publish(AGENT_LOADED, null);
}
